type Attrs = Record<string, string>;
export const createScript = (attrs?: Attrs, removeAsync?: boolean) => {
    const scriptTag = document.createElement('script');

    scriptTag.classList.add('protected');
    !removeAsync && scriptTag.setAttribute('async', '');
    scriptTag.setAttribute('type', 'text/javascript');
    scriptTag.setAttribute('charset', 'UTF-8');
    if (attrs) {
        Object.keys(attrs).forEach(k => {
            scriptTag.setAttribute(k, attrs[k]);
        });
    }
    return scriptTag;
};

export const appendScriptByURL = (src: string, attrs?: Attrs) => {
    const scriptTag = createScript(attrs);
    scriptTag.src = src;
    document.head.appendChild(scriptTag);
};

export const appendScriptBySource = (
    src: string,
    attrs?: Attrs,
    removeAsync?: boolean,
) => {
    const scriptTag = createScript(attrs, removeAsync);
    scriptTag.innerHTML = src;
    document.head.appendChild(scriptTag);
};

export const appendMetaTagToHead = (attrs: Attrs) => {
    const metaTag = document.createElement('meta');
    metaTag.setAttribute('class', 'protected');
    if (attrs) {
        Object.keys(attrs).forEach(k => {
            metaTag.setAttribute(k, attrs[k]);
        });
    }
    document.head.appendChild(metaTag);
};
